import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';
import Alert from '@mui/material/Alert';

const useStyles = makeStyles()({
  tooltip: {
    // Make transparent bg and no padding so we only see the alert
    backgroundColor: 'rgba(0, 0, 0, 0)',
    padding: '0px',
    filter: 'drop-shadow(0 0 2px black)',
  },
});

const TooltipAlert = ({ children, severity = 'success', message, placement = 'bottom' }) => {
  const { classes } = useStyles();
  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={<Alert severity={severity}>{message}</Alert>}
      placement={placement}
    >
      {children}
    </Tooltip>
  );
};

TooltipAlert.propTypes = {
  children: PropTypes.node.isRequired,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  placement: PropTypes.oneOf([
    'bottom',
    'left',
    'right',
    'top',
    'bottom-start',
    'left-start',
    'right-start',
    'top-start',
    'bottom-end',
    'left-end',
    'right-end',
    'top-end',
  ]),
  message: PropTypes.string.isRequired,
};



export default TooltipAlert;
